var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColorAdvertisement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6966 4.19995H17.9966C17.444 4.19995 16.9831 4.60403 16.8761 5.14139L9.81616 7.73109H6.26483C5.2906 7.73109 4.5 8.54588 4.5 9.55124V11.8641C4.5 12.8695 5.29001 13.6843 6.26483 13.6843H9.81616L16.8527 15.9332V16.0364C16.8527 16.6877 17.365 17.216 17.9966 17.216H18.6966C19.3281 17.216 19.8404 16.6877 19.8404 16.0364V5.38022C19.8404 4.72887 19.3281 4.20055 18.6966 4.20055V4.19995Z",
    fill: "url(#paint0_linear_468_75777)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3777 19.8149H8.32835C7.70071 19.8149 7.08421 19.2959 6.9506 18.6556L5.51012 12.8666C5.37651 12.2263 5.77736 11.7073 6.405 11.7073H8.45437C9.08201 11.7073 9.6985 12.2263 9.83212 12.8666L11.2726 18.6556C11.4062 19.2959 11.0054 19.8149 10.3777 19.8149Z",
    fill: "url(#paint1_linear_468_75777)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3777 19.836H8.32836C7.69252 19.836 7.06488 19.3082 6.9301 18.6597L5.48962 12.8718C5.42164 12.5455 5.48554 12.2421 5.66955 12.0166C5.84302 11.8033 6.10379 11.6862 6.40501 11.6862H8.45438C9.09023 11.6862 9.71786 12.214 9.85265 12.8625L11.2931 18.6503C11.3611 18.9766 11.2972 19.28 11.1132 19.5056C10.9397 19.7188 10.679 19.836 10.3777 19.836ZM6.40501 11.7278C6.11668 11.7278 5.86763 11.8396 5.70237 12.0423C5.52656 12.2579 5.46618 12.5491 5.53123 12.8619L6.9717 18.6497C7.10297 19.2806 7.71187 19.7932 8.32896 19.7932H10.3783C10.6666 19.7932 10.9157 19.6813 11.081 19.4786C11.2568 19.2631 11.3171 18.9719 11.2521 18.6591L9.81162 12.8713C9.68034 12.2403 9.07148 11.7278 8.45438 11.7278H6.40501Z",
    fill: "url(#paint2_linear_468_75777)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_468_75777",
    x1: 6.7871,
    y1: 4.59035,
    x2: 15.6702,
    y2: 16.5039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18B7F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#185EF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_468_75777",
    x1: 5.48444,
    y1: 15.7613,
    x2: 11.2983,
    y2: 15.7613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8E7E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_468_75777",
    x1: 5.46313,
    y1: 15.7612,
    x2: 11.3196,
    y2: 15.7612,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8E7E7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorAdvertisement);
export default __webpack_public_path__ + "static/media/color-advertisement.97de62df290e38be7481db73de29068a.svg";
export { ForwardRef as ReactComponent };